import PassengerBox from './PassengerBox'
import AirportSelector from './AirportSelector'
import Validation from "./SearchBox.Validation";

import theme from '../../theme'
import axios from 'axios'
import SearchBoxService from "../../services/searchBox.service";
import Helper from "../helper";
import VueClipboard from 'vue-clipboard2'
import UiCaptions from '../../Languages/FlightSearch/SearchBox.lang';
// eslint-disable-next-line
import SearchBoxShare from "./SearchBox.shared.js";

const MulticityBox = {
  directives:[VueClipboard],
  created(){
      this.loadCityAirports();
      this.getAirlinesForSelection();
      if (this.P_SearchCriteriaBase64M!=null && this.P_SearchCriteriaBase64M!=""){
          // this.readSearchFilteringValuesFromPara();
          if(this.$store.state.triptype!=null && this.$store.state.triptype=="M" && this.$store.state.searchBoxValues.origin!=undefined){
              // this.readStoredSearchFilteringValues();
          }else{
          this.$store.commit("updateSearchCriteriaBase64M",null);
          this.$router.push({name:'SharedLink',params:{sid:this.P_SearchCriteriaBase64M}});
          }
      }
      // else{
      //     this.readStoredSearchFilteringValues();    
      // }
      this.readStoredSearchFilteringValues();
      this.getBackToHomeUrl();
  },
  props:['SelectedLanguage','P_WholesaleId','P_UrlId','P_SearchCriteriaBase64M'],
  components:{
      PassengerBox, AirportSelector,
  },
  data(){
      return {
          uiCaptions:UiCaptions,
          helper:Helper,
          buttonGroupDefaults:[0,1],
          searchBoxControlsDisabilities:{
              originSelector:false,
              destinationSelector:false,
              airlineSelector:false,
              dateOfDeparturePicker:false,
              dateOfReturnPicker:false,
              passengerPicker:false,
              searchButton:false,
              copyLinkButton:false,
          },
          validation:{
              showAlert:false,
              message:"",
          },
          storedSearchBoxValues:{
              // origin:"",
              // destination:"",
              // departureDate:null,
              // returnDate:null,
              originM:[],
              destinationM:[],
              departureDateM:[],
              trip:false,
              seatClass:"",
              airline:"--",
              passengerCountByPax:{
                  adult:0,
                  child:0,
                  infant:0,
                  student:0,
              },
          },
          searchPara:{
              wholesaleId:35,
              urlId:382,
              trip:"M",
              airline:"--",
              origin1:"",
              destination1:"",
              departureDate1:"",
              originM:[],
              destinationM:[],
              departureDateM:[],
              seatClass:"",
              adtPassengerCount:0,
              cnnPassengerCount:0,
              infPassengerCount:0,
              stuPassengerCount:0,
              markupLevel:0,
              styleName:"1G1",
              language:this.SelectedLanguage,
              flightType:"0",
              totalSector:2              
          },
          flightFares:null,
          indeterminate:false,
          showSearchBox:true,
          seatClasses:[
              {text:'Economy', value:'Y'},
              {text:'Business', value:'C'},
              {text:'First', value:'F'}
          ],
          defaultColors:{
              primary:theme.primary.base,
              secondary:theme.secondary
          },
          showFareIndices:[1,7,13,300],
          emitters:{
              SearchId:'SearchId'
          },
          searchId:null,
          cityAirports:[],              
          backToHomeUrl:"",
          snackbar:{
              show:false,
              text:"",
          },
          airlines:[],
          linkToCopy:"",
          showCopyLinkDialog:false,
          lnkAdd:true,
          inputs: [
          {
              name: ''
          },
          {
              name: ''
          }
          ],
          isbackurl:false
      }
  },
  methods:{
      onCopyToClipboard(){
          this.showCopyLinkDialog = false;       
          setTimeout(() => {
              this.snackbar.text = "Shared url coppied.";
              this.snackbar.show = true;  
          }, 1000);   
      },
      onCopyToClipboardErr(){
          this.showCopyLinkDialog = false;
          setTimeout(() => {
              this.snackbar.text = "Cannot coppy.";
              this.snackbar.show = true;  
          }, 1000);                       
      },
      copyLinkDialogClick(){
          this.showCopyLinkDialog = false;
      },
      getAirlinesForSelection(){
          SearchBoxService.getAirlines().then((rslt)=>{
              this.airlines = [];
              if (rslt.data!=null && rslt.data.length>0){
                  var items = rslt.data;
                  items.forEach((al)=>{
                      this.airlines.push(
                          al.Code +" - " + al.Name
                      )
                  })
              }
          });
      },
      getBackToHomeUrl(){
          SearchBoxService.getBackToHomeUrl().then((rslt=>{
              this.backToHomeUrl = rslt.data;
              if (this.backToHomeUrl.indexOf('http://')<0||
              this.backToHomeUrl.indexOf('https://')>0){
                  this.backToHomeUrl = "http://" + this.backToHomeUrl;
              }
          }));
      },
      departureDateChanged(index){
          try{            
          var lst=this.searchPara.departureDateM;
          let date1=lst[index];
          if (date1.length==10){
              let m1 = parseInt( date1.split("-")[0] + date1.split("-")[1] + date1.split("-")[2]);
              for (let i = index; i < this.searchPara.totalSector; i++){
                  if(i!=0){
                      let date2 = lst[i];
                      if (date2==undefined){
                          this.searchPara.departureDateM[i] = date1;
                      }else {
                          if (date2.length==10){
                              let m2 = parseInt(date2.split("-")[0] + date2.split("-")[1] + date2.split("-")[2]);
                              if (m1>m2){
                                  this.searchPara.departureDateM[i] = date1;
                              }
                          }
                      }
                  }
              }
              this.searchPara.departureDateM=lst;
          }
          }catch(e){
              console.error(e.message);
          }

      }, 
      copyLink() {
          SearchBoxService.getSharedSearchResultUrl().then((result)=>{
              //alert(result.data);
              this.linkToCopy = result.data;
              this.$copyText(result.data).then(()=>{
                  this.snackbar.text = "Shared url coppied.";
                  this.snackbar.show = true;
              },()=>{
                  this.showCopyLinkDialog = true;
              });
              //
          });            
      },              
      validateSearchPara(){

          this.validation.showAlert = false;
          this.validation.message = "";

          let vald = Validation.validateSearchPara(this.searchPara); 
          this.validation.showAlert = vald.showAlert;
          this.validation.message = vald.message;
          return vald.errorCode;
      },
      readSearchFilteringValuesFromPara(){

          SearchBoxService.decodeFlightSearchBoxValues(this.P_SearchCriteriaBase64M).then((rslt)=>{              
              let srchCri = rslt.data;
              if(srchCri.TripType!=null && srchCri.TripType=="M"){
              
              this.storedSearchBoxValues.trip = srchCri.Trip;
              this.storedSearchBoxValues.originM = srchCri.Origin.split('~');
              this.storedSearchBoxValues.destinationM = srchCri.Destination.split('~');
              this.storedSearchBoxValues.departureDateM = srchCri.DepartureDate.split('~');
              // this.storedSearchBoxValues.returnDate = this.$store.state.searchBoxValues.dateOfReturn;
              this.storedSearchBoxValues.airline = srchCri.Airline;
              this.storedSearchBoxValues.seatClass = srchCri.SeatClass;
              this.storedSearchBoxValues.passengerCountByPax.adult = srchCri.AdultCount;
              this.storedSearchBoxValues.passengerCountByPax.child = srchCri.ChildCount;
              this.storedSearchBoxValues.passengerCountByPax.infant = srchCri.InfantCount;

              this.searchPara.originM = srchCri.Origin.split('~');
              this.searchPara.destinationM = srchCri.Destination.split('~');                
              this.searchPara.departureDateM = srchCri.DepartureDate.split('~');
              // this.searchPara.returnDate = this.storedSearchBoxValues.returnDate;
              this.searchPara.trip = this.storedSearchBoxValues.trip;
              this.searchPara.seatClass = this.storedSearchBoxValues.seatClass;
              this.searchPara.urlId = this.$store.state.urlId;
              this.searchPara.totalSector=this.searchPara.departureDateM.length;
              this.inputs=[];
              for (let index = 0; index < this.searchPara.totalSector; index++) {
                  this.inputs.push({ name: '' });
              }
              this.$store.commit('updateSearchBoxValues',this.searchPara);
              this.isbackurl=true;
              this.$store.commit("updateSearchCriteriaBase64M",null);

              if (srchCri.Origin!=null&&
                  srchCri.Origin!=""){
                  setTimeout(()=>{
                      this.submitSearch(this.searchPara);
                  },2000); 
              }  
              }
          });

        
      },
      readStoredSearchFilteringValues(){
          let fncSplit = function (valueToSplit) {
            let rslt = [];
            if (valueToSplit && valueToSplit.indexOf('~')>=0) {
               rslt = valueToSplit.split('~');
            }
            return rslt;
          }
          if(this.$store.state.triptype!=null && this.$store.state.triptype=="M"){
              this.storedSearchBoxValues.trip = this.$store.state.searchBoxValues.trip;
              this.storedSearchBoxValues.originM = fncSplit(this.$store.state.searchBoxValues.origin);
              this.storedSearchBoxValues.destinationM = fncSplit(this.$store.state.searchBoxValues.destination);
              this.storedSearchBoxValues.departureDateM =fncSplit(this.$store.state.searchBoxValues.dateOfDeparture);
              this.storedSearchBoxValues.returnDate = this.$store.state.searchBoxValues.dateOfReturn;
              this.storedSearchBoxValues.airline = this.$store.state.searchBoxValues.airline;
              this.storedSearchBoxValues.seatClass = this.$store.state.searchBoxValues.seatClass;
              this.storedSearchBoxValues.passengerCountByPax.adult = this.$store.state.searchBoxValues.passengerCountByPax.adult;

              this.storedSearchBoxValues.passengerCountByPax.child = this.$store.state.searchBoxValues.passengerCountByPax.child;
              this.storedSearchBoxValues.passengerCountByPax.infant = this.$store.state.searchBoxValues.passengerCountByPax.infant;

              this.searchPara.departureDateM = fncSplit(this.$store.state.searchBoxValues.dateOfDeparture);
              this.searchPara.returnDate = this.storedSearchBoxValues.returnDate;
              this.searchPara.trip = this.storedSearchBoxValues.trip;
              this.searchPara.seatClass = this.storedSearchBoxValues.seatClass;
              this.searchPara.urlId = this.$store.state.urlId;
              this.searchPara.totalSector=this.searchPara.departureDateM.length;
              this.inputs=[];
              for (let index = 0; index < this.searchPara.totalSector; index++) {
                  this.inputs.push({ name: '' });
              }                
              if (this.$store.state.searchBoxValues.origin!=null&&
              this.$store.state.searchBoxValues.origin!=""){
                  setTimeout(()=>{
                      this.submitSearch(this.searchPara);
                  },2000); 
              }
          }
          if (this.storedSearchBoxValues.passengerCountByPax.adult == 0){this.storedSearchBoxValues.passengerCountByPax.adult = 1}
      },
      stopLoadingUis(){
          this.indeterminate = false;
          this.$emit('LoadingAirlines',false);
      },
      getSeatClassByCode(code){
          var cls = this.seatClasses.filter(c=>c.value==code);
          return cls[0]==null?"":cls[0].text;
      },
      submitSearch(searchPara){
          try{
              if(this.isbackurl==true){
                  this.searchPara.adtPassengerCount = this.storedSearchBoxValues.passengerCountByPax.adult;
                  this.searchPara.cnnPassengerCount = this.storedSearchBoxValues.passengerCountByPax.child;
                  this.searchPara.infPassengerCount = this.storedSearchBoxValues.passengerCountByPax.infant;
                  this.searchPara.stuPassengerCount = this.storedSearchBoxValues.passengerCountByPax.student;
                  this.isbackurl=false;
              }
              this.$emit('FlightFares',[]);
              this.$emit('LoadingAirlines',true);
              this.$emit('AirlinesForFiltering',[]);
              this.$emit('SearchPara',searchPara);
              this.$store.commit('updateSearchBoxValues',searchPara);
              this.$store.commit('updateWholesaleIdAndUrlId',[this.P_WholesaleId,this.P_UrlId]);
              this.searchPara.wholesaleId = this.P_WholesaleId;
              this.searchPara.urlId = this.P_UrlId;
              searchPara.language = this.SelectedLanguage
              this.searchPara.totalSector=this.inputs.length;
              // var para = getSearchPara(searchPara);
              var para = SearchBoxShare.getSearchParaForMultiCity(searchPara);
              this.indeterminate = true;
              this.flightFares= [];

              if (this.validateSearchPara()>0) {
                  this.indeterminate =false; 
                  return;
              }

              this.disableSearchBoxControls();
              
              axios.post ('/api/SearchBox/CreateFlightSearch',para)
                  .then (
                      result=>this.searchFlight(result.data)
                  )
                  .catch(() => {
                      console.error;
                      this.stopLoadingUis();
                      this.enableSearchBoxControls();
                  });
                  this.$emit('FlightFares',[]);
                  this.$emit('LoadingAirlines',true);
                  this.$emit('AirlinesForFiltering',[]);
                  this.$store.commit('updateSearchBoxValues',searchPara);
                  this.$store.commit('updateWholesaleIdAndUrlId',[this.P_WholesaleId,this.P_UrlId]);
          }
          catch(err){
              this.enableSearchBoxControls();
          }
      },
      searchFlight(para){
          try{
              // let url = '/api/Go/SearchFlightForResponsive?';
              let url = '/api/Go/CacheSearchInfo?'
              axios.get(url+para).then(
                  result=>{
                      this.Flight2C_1(result.data);
                      this.searchId = para.replace("go=","");
                      this.$store.commit("updateSearchCriteriaBase64M",this.searchId);
                  }
              ).catch(() => {
                      console.error;
                      this.stopLoadingUis();
                      this.enableSearchBoxControls();
              });                 
          }
          catch(err){
              this.enableSearchBoxControls();
          }
      },
      Flight2C_1(para){
          try{
              axios.get('/api/Go/Flight2C_1ForResponsive?go='+para).then(result=>{
                      if (result.data=="OK"){
                          this.SubmitRouting();
                      } else {
                        throw "ERROR: SearchId not found."
                      }
                  }
              ).catch((e) => {
                  console.error(e);
                  this.stopLoadingUis();
                  this.enableSearchBoxControls();
              }); 
          }catch(err){this.enableSearchBoxControls();}
      },
      SubmitRouting(){
          try{
              axios.post('/api/Flight2C_1/SubmitRouting').then(
                  // eslint-disable-next-line no-unused-vars
                  result=>{
                  this.ShowFareIndex()}
              )
              .catch(() => {
                  console.error;
                  this.stopLoadingUis();
                  this.enableSearchBoxControls();
              }); 
          }catch(err){this.enableSearchBoxControls();}
      },
      ShowFareIndex(strtInd){
          if (strtInd==null) strtInd=0;
          try{
              axios.post('/api/Flight2C_1/ShowFareIndexForResponsive',{startFareInd:this.showFareIndices[strtInd]}).then(
                  result=>{
                      
                      this.showSearchBox = false;
                      this.$emit('ShowSearchBox',this.showSearchBox);
                      if (typeof result.data=="string"){
                          //this.$emit('ResponseMessage',result.data);
                          if(strtInd==0) {
                              this.$emit('FlightFares',null);
                              this.$emit('ResponseMessage','Search result is not available.');
                          }else if (strtInd>0){
                              this.indeterminate = false;
                              this.$emit(this.emitters.SearchId,this.searchId);
                              this.getAirlines();
                          }
                          this.stopLoadingUis();
                      }else{
                              result.data.forEach((item)=>{
                                  this.flightFares.push(item);
                              })  
                          
                          if (strtInd<4) this.ShowFareIndex(strtInd+1);
                          this.$emit('FlightFares',this.flightFares);
                      }
                      this.enableSearchBoxControls();
                  }
              )
              .catch(() =>{
                  console.error;
                  this.stopLoadingUis();
                  this.enableSearchBoxControls();
              });              
          }catch(err){
              this.enableSearchBoxControls();
          }
      },
      getPassengerCounts(c){
          this.searchPara.adtPassengerCount = c.adt;
          this.searchPara.cnnPassengerCount = c.cnn;
          this.searchPara.infPassengerCount = c.inf;
          this.searchPara.stuPassengerCount = c.stu;
          this.$emit('PassengerCountsByType',{
              adultCount:c.adt,
              childCount:c.cnn,
              infantCount:c.inf,
              studentCount:c.stu
          })
      },
      hideSearchBox(){
          this.showSearchBox=false;
          // this.$emit('ShowSearchBox',showSearchBox);
      },
      enableSearchBoxControls(){
          let disabled = false;
          this.searchBoxControlsDisabilities.originSelector =disabled;
          this.searchBoxControlsDisabilities.destinationSelector = disabled;
          this.searchBoxControlsDisabilities.airlineSelector = disabled;
          this.searchBoxControlsDisabilities.dateOfDeparturePicker = disabled;
          this.searchBoxControlsDisabilities.dateOfReturnPicker = disabled;
          this.searchBoxControlsDisabilities.passengerPicker = disabled;
          this.searchBoxControlsDisabilities.searchButton = disabled;
          this.searchBoxControlsDisabilities.copyLinkButton = disabled;
      },
      disableSearchBoxControls(){
          let disabled = true;
          this.searchBoxControlsDisabilities.originSelector =disabled;
          this.searchBoxControlsDisabilities.destinationSelector = disabled;
          this.searchBoxControlsDisabilities.airlineSelector = disabled;
          this.searchBoxControlsDisabilities.dateOfDeparturePicker = disabled;
          this.searchBoxControlsDisabilities.dateOfReturnPicker = disabled;
          this.searchBoxControlsDisabilities.passengerPicker = disabled;
          this.searchBoxControlsDisabilities.searchButton = disabled;
          this.searchBoxControlsDisabilities.copyLinkButton = disabled;
      },
      getAirlines(){
          
          var airlines = [];
          // this.flightFares.forEach((item)=>{
          //     //if (airlineCodes.indexOf(item.Airline)<0) airlineCodes.push(item.Airline);
          //     airlines.push({
          //         Code:item.Airline,
          //         Name:null,
          //         Price:item.AdultFare
          //     });
          // });
          this.flightFares.forEach((item)=>{
              //if (airlineCodes.indexOf(item.Airline)<0) airlineCodes.push(item.Airline);
              item.PricingBoxGroup.forEach((pricegrp)=>{
                  pricegrp.PricingBox.forEach((pricebx)=>{
                  airlines.push({
                  Code:pricebx.Airline,
                  Name:null,
                  Price:pricebx.AdultFare
              });
              });                
              });
          });        
          axios.post('/api/SearchBox/GetAirlineNames',airlines).then(result=>{
              var airlines = result.data.airlines;
              var minPrice = result.data.minPrice;
              var maxPrice = result.data.maxPrice;
              this.$emit('AirlinesForFiltering',airlines);
              this.$emit('LoadingAirlines',false);
              this.$emit('PriceMinMaxForFiltering',[minPrice,maxPrice]);
          }).catch(()=>{
              console.error;
          }
          );
      },
      loadCityAirports(){
          SearchBoxService.getCityAirports("").then(rslt=>{
              this.cityAirports = rslt.data;
          });
      },
      add() {
          // if(index==1){
          //     var hh=""
          // }
          this.inputs.push({ name: '' });
          if(this.inputs.length==8){
              this.lnkAdd=false;
          }  
          this.searchPara.totalSector=this.inputs.length;          
      },
      remove(index) {
          if(this.inputs.length>2){                 
          this.inputs.splice(index, 1);
          }
          if (this.inputs.length < 8) {                   
                 this.lnkAdd=true
              }  
          this.searchPara.totalSector=this.inputs.length;         
      },
      lnkedit(){
          this.showSearchBox=this.showSearchBox!=true;
          this.$emit('ShowSearchBox',this.showSearchBox);
      },
      getAirportCode(ap){
          try {
              var code = ap.split('-')[0];
              code = code.trim();                
              return code;            
          } catch (error) {
              return "";
          }
      },
  },
  computed:{
      isMobile(){
          let isMobile = Helper.display.isMobile(this.$vuetify.breakpoint.name);
          return isMobile;
      },
      selectedSeatClass(){
          let text = "";
          let conVals = ["","--"];
          if (conVals.indexOf(this.searchPara.airline.trim())>=0){
              text = this.getSeatClassByCode(this.searchPara.seatClass);
          }else {
              text = this.searchPara.airline +" (" + this.getSeatClassByCode(this.searchPara.seatClass) + ")";
          }
          return text;
      },
  },
}

export default MulticityBox;